import { get } from 'lodash';
import type { IGcfProductList } from 'src/interfaces';
import { extractProductsFromGCFGroups } from 'src/utils';

export const validateAnimationDelays = (productList: IGcfProductList) => {
  let isValid = true;

  const { products } = extractProductsFromGCFGroups(productList.groups);

  for (const product of products) {
    const { animation } = product.config;

    if (animation) {
      if (
        get(animation, 'in.delay', 0) >= get(animation, 'out.delay', Infinity)
      ) {
        return false;
      }

      for (const animationValue of Object.values(animation)) {
        if (
          get(animationValue, 'in.delay', 0) >=
          get(animationValue, 'out.delay', Infinity)
        ) {
          return false;
        }
      }
    }
  }

  return isValid;
};
